import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { SetupStatusResponse } from '../lib/api-client';
import { setupApi } from '../lib/api-client';
import { queryKeys } from '../lib/query-keys';

export function useSetupStatus(orgPid: string) {
  return useQuery<SetupStatusResponse>({
    queryKey: queryKeys.setup.status(orgPid),
    queryFn: () => setupApi.getStatus(orgPid),
    refetchInterval: false,
  });
}

export function useValidateKey(orgPid: string) {
  return useMutation({
    mutationFn: (data: { provider: 'mmk'; apiKey: string }) => setupApi.validateKey(orgPid, data),
  });
}

export function useConnect(orgPid: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { provider: 'mmk'; apiKey: string; companyExternalId: string }) =>
      setupApi.connect(orgPid, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.setup.status(orgPid) });
    },
  });
}

export function useRetrySync(orgPid: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { fromPhase: 'yachts' | 'availability' | 'reservations' }) =>
      setupApi.retry(orgPid, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.setup.status(orgPid) });
    },
  });
}
